import $ from 'jquery';

export default function articlePeople() {
  const section = $('.section--article-people');
  const separateContent = $('.section__content--separate');
  const btn = section.find('.section__button');

  btn.on('click', function () {
    if (separateContent.length > 0) separateContent.addClass('is-active');
    btn.addClass('d-none');
  });
};
